/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
var addressToString = require('common/util/addressToString');
var _ = require('underscore');

module.exports = function(searchBody, lookupHashes) {
  var deferred = $.Deferred();

  var entityTypes = lookupHashes.entityTypes || {};
  var organizationTypes = lookupHashes.organizationTypes || {};

  $.soap({
    body: {
      PerformElasticSearch: {
        $xmlns: 'http://dobs.pa.gov/cm/search/bpm/1.0',
        IndexName: 'co-entity',
        SearchBody: JSON.stringify(searchBody)
      }
    },
    blueprint: {
      searchResults: '$..Response'
    }
  }).done(function(result) {
    var searchResult = JSON.parse(result.searchResults);

    var hits = _.map(searchResult.hits.hits, function(hit) {
      var result = hit._source;
      result.entityName = result.entityName || '';
      result.streetAddress = result.streetAddress || '';
      result.county = result.county || '';
      result.city = result.city || '';
      result.state = result.state || '';
      result.postalCode = result.postalCode || '';

      result.fullAddress = addressToString({
        addressLine1: result.streetAddress,
        city: result.city,
        state: result.state
      });

      /*if (result.streetAddress) {
        result.streetAddress = result.streetAddress + ', ' + result.county + ', ' + result.state;
      }*/

      if (result.entityTypeId) {
        result.entityType = entityTypes[result.entityTypeId];
      }

      if (result.organizationTypeId) {
        result.organizationType = organizationTypes[result.organizationTypeId];
      }

      result.relatedContactsList = [];
      if (result.relatedContacts) {
        _.map(result.relatedContacts, function(contact) {
          result.relatedContactsList.push({
            value: contact.contactName,
            href: '#coc/contact/' + contact.contactId + '/dashboard'
          });
        });
      }
      return result;
    });

    var results = {
      hits: hits,
      totalHits: searchResult.hits.total.value,
      took: searchResult.took
    };
    deferred.resolve(results);
  });

  return deferred.promise();
};
